import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import {
  BadgeEuro,
  Calculator,
  Camera,
  Clipboard,
  ClipboardList,
  FileInput,
  FileOutput,
  FileText,
  ListChecks,
  ShieldCheck,
} from "lucide-react";
import { cn } from "@/shared/lib/utils";
import { DocumentKind } from "@bitory-gmbh/bsm";

export interface DocumentIconProps {
  documentKind: DocumentKind;
  className?: string;
}

export const DocumentIconCalculation = Calculator;
export const DocumentIconCertificate = ShieldCheck;
export const DocumentIconConfirmation = FileOutput;
export const DocumentIconContract = ShieldCheck;
export const DocumentIconDocumentation = Camera;
export const DocumentIconLastMinuteRiskAnalysis = ListChecks;
export const DocumentIconOffer = BadgeEuro;
export const DocumentIconOrder = FileInput;
export const DocumentIconReport = FileText;
export const DocumentIconRequirement = Clipboard;
export const DocumentIconSummaryReport = FileText;
export const DocumentIconTreatment = Clipboard;
export const DocumentIconWorkOrder = ClipboardList;

export function DocumentIcon({
  documentKind,
  className = "",
}: DocumentIconProps) {
  switch (documentKind) {
    case GSMDocumentKind.Calculation:
      return <DocumentIconCalculation className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Certificate:
      return <DocumentIconCertificate className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Confirmation:
      return <DocumentIconConfirmation className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Contract:
      return <DocumentIconContract className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Documentation:
      return <DocumentIconDocumentation className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.LastMinuteRiskAnalysis:
      return (
        <DocumentIconLastMinuteRiskAnalysis
          className={cn("h-5 w-5", className)}
        />
      );
    case GSMDocumentKind.Offer:
      return <DocumentIconOffer className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Order:
      return <DocumentIconOrder className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Report:
      return <DocumentIconReport className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Requirement:
      return <DocumentIconRequirement className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.SummaryReport:
      return <DocumentIconSummaryReport className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.Treatment:
      return <DocumentIconTreatment className={cn("h-5 w-5", className)} />;
    case GSMDocumentKind.WorkOrder:
      return <DocumentIconWorkOrder className={cn("h-5 w-5", className)} />;
    default:
      return <span>{documentKind}</span>;
  }
}
